import React, { useState, useEffect, useMemo } from "react";
import { Control, actions } from "react-redux-form";
import { Button, Card, Col, Row, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { compose, withHandlers, withPropsOnChange } from "recompose";
import { useHistory, useLocation } from "react-router-dom";
import {
    FormGroup,
    DatePicker,
    Select,
    Input,
} from "components/react-hook-form";
import {
    useForm,
    FormProvider,
    useFieldArray,
} from "react-hook-form";


import { pick, update } from "lodash";
import { Trans, withTranslation } from "react-i18next";
import { CurrencySymbol, formatDateName, formatXeroDate } from "services/util";
import { NotificationManager } from "react-notifications";
import { Page } from "components/common";
import BackButton from "components/refactoring/BackButton";
import { XeroClient } from "services";


const EditBatchPayment = ({ match, t, location }) => {
    // const location = useLocation();
    const xero = XeroClient();
    const [accounts, setAccounts] = useState([]);
    const history = useHistory();

    const invoices = location?.state || [];
    let Reference_Or_Details = null;
    if ( invoices[0]?.Type === "ACCPAY" ) {
        Reference_Or_Details = "Details";
    } else {
        Reference_Or_Details = "Reference";
    }
    let contactIds = [];
    if (invoices){
        contactIds = [...new Set(invoices?.map(item => item?.Contact?.ContactID))];
    };

    
    const id = match?.params?.id;

    const methods = useForm({
        mode: "onBlur"
    });
    const { reset, control, setValue, handleSubmit, watch, getValues, unregister } = methods;

    const { fields, remove, append } = useFieldArray({
        control,
        name: "Payments",
        keyName: "key",
    });

    const fetchBankBankDetailsAndDeconstructData = async () => {
        try {
            const response = await xero.get(`contacts`, { params: { extra_params: { IDs: contactIds } } });
            const bankAccountDetails = response?.data;
    
            const bankDetailsMap = bankAccountDetails.reduce((acc, detail) => {
                acc[detail.ContactID] = detail;
                return acc;
            }, {});
    
            const batch_payment = invoices.map(item => ({
                ...{
                    Invoice: {
                        InvoiceID: item.InvoiceID
                    },
                    AmountDue:item.AmountDue,
                    Amount:item.AmountDue,
                    Reference :item.Type==="ACCPAY"? undefined:item.Reference,
                    Details :item.Details,
                    // Details: item.Details,
                    DueDateString: item?.DueDateString,
                    Contact: {
                        Name: item.Contact?.Name,
                        BankAccountDetails: bankDetailsMap[item.Contact?.ContactID]?.BankAccountDetails
                    }
                }
            }));
            
            

            reset({Status:"AUTHORISED", Payments:batch_payment});
              
        } catch (error) {
            console.error("Error fetching bank account details:", error);
        }
    };

    useEffect(() => {
        const getContacts = async () => {
            fetchBankBankDetailsAndDeconstructData();
        };
        getContacts();
    }, []);
    
    useEffect(() => {
        getAccounts();
    }, []);

    const bankTypes = ["BANK", "LIABILITY", "EQUITY"];

    const getAccounts = () => {
        xero.get("accounts").then((data) => {
            setAccounts(data.data);
        });
    };
    const filteredAccounts = useMemo(() => {
        return accounts.filter(account => bankTypes.includes(account?.Type));
    }, [accounts, bankTypes]);

    const defaultOptions = filteredAccounts.map((i) => ({
        value: i?.AccountID,
        label: i?.Name,
    }));

    const handleBatchPaymentSubmit = async (values) => {

        const Payments = values.Payments.map((item, index )=>{
            const {Contact, ...data} = item;
            return data
        });

          if (id === "new"){
            const response = await xero.post("batchpayments", {
                ...values, Payments: Payments});
            
            history.push({pathname: `/batch-payments/view/${response.data?.BatchPaymentID}`, state: {response: response.data, Payments: Payments, Contacts: values?.Payments }});
            NotificationManager.success(t("Batch Payment created Successfully."));
          };
          
    }


    return (
        <Page title={"Edit Batch Payment"}>
            <BackButton />
            <FormProvider {...methods}>
                <Row className="justify-content-center align-items-center d-flex">
                    <Col md="6">
                        <FormGroup label={t("Payment Date")}>
                            <DatePicker
                                className="form-control form-control-sm"
                                name="Date"
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup label={t("Bank Account")}>
                            <Select style={{ backgroundColor: '#F4F7FE' }}
                                name="Account.AccountID"
                                options={defaultOptions}
                                simpleValue
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup className="mt-2" label={t("Details")}>
                    <Input
                        className="form-control form-control-sm"
                        name={`${Reference_Or_Details}`}
                        placeholder="Details"
                    />
                </FormGroup>
                <Table>
                    <thead>
                        <tr>
                            <th className="text-center"><Trans>To</Trans></th>
                            <th className="text-center"><Trans>Reference</Trans></th>
                            <th className="text-center"><Trans>Due Date</Trans></th>
                            <th className="text-center"><Trans>Bank Account</Trans></th>
                            {Reference_Or_Details === "Details" && (<th className="text-center"><Trans>Details</Trans></th>)}
                            <th className="text-center"><Trans>Due</Trans> <CurrencySymbol currency={invoices[0]?.CurrencyCode}/></th>
                            <th className="text-center"><Trans>Payment</Trans> <CurrencySymbol currency={invoices[0]?.CurrencyCode}/></th>
                            <th className="text-center"><Trans>Actions</Trans></th>
                            <th className="text-right" />
                        </tr>
                    </thead>
                    <tbody>
                        {fields?.map((payment, index) => {
                            const n = (v) => `Payments.${index}.${v}`;

                            return (
                                <tr key={index}>
                                    <td scope="row">{payment?.Contact?.Name}</td>
                                    <td className="text-center">
                                        {payment?.Reference}
                                    </td>
                                    <td className="text-center">
                                        {formatDateName(payment?.DueDateString)}
                                    </td>
                                    <td className="text-center">
                                        <FormGroup className="d-flex justify-content-center align-items-center">
                                            <Input
                                                type='text'
                                                name={Reference_Or_Details === "Details" ? n("BankAccountNumber") : n("BankAccountDetails")}
                                                defaultValue={payment?.Contact?.BankAccountDetails}
                                            />
                                        </FormGroup>
                                    </td>
                                    {Reference_Or_Details === "Details" && (
                                        <td className="text-center">
                                        <FormGroup className="d-flex justify-content-center align-items-center">
                                            <Input
                                                type='text'
                                                name={n(`Details`)}
                                            />
                                        </FormGroup>
                                    </td>
                                    )}
                                    <td className="text-center">
                                        {payment?.AmountDue}
                                    </td>
                                    <td className="text-center">
                                        <FormGroup className="d-flex justify-content-center align-items-center">
                                            <Input
                                                type='text'
                                                name={n("Amount")}
                                                defaultValue={payment?.AmountDue}
                                            />
                                        </FormGroup>
                                    </td>
                                    <td className="text-center">
                                        <div className="d-flex justify-content-center align-items-center">
                                            <Button color="" onClick={() => remove(payment?.key)}><span className="fa fa-times text-danger"></span></Button>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}

                    </tbody>

                </Table>
                <div className="row">
                    <div className="col">
                        <div className="d-flex justify-content-end align-items-center">
                            <Button className="text-right" color="primary" onClick={handleSubmit(handleBatchPaymentSubmit)}><Trans>Make Payments</Trans></Button>
                        </div>
                    </div>
                </div>
            </FormProvider>
        </Page>
    );
};

export default EditBatchPayment;
